export default __webpack_public_path__ + "static/media/pp.baa1c557.jpg";